(function () {
  function getCartItems() {
    return (
      document.querySelector('cart-items') ||
      document.querySelector('cart-drawer-items')
    );
  }

  function getContainer(element) {
    return element.closest('.cart-discount-component');
  }

  function setLoading(container, loading) {
    if (!container) return;

    const input = container.querySelector('.js-cart-discount-input');
    const button = container.querySelector('.js-cart-discount-apply');

    if (input) input.disabled = loading;
    if (button) button.disabled = loading;
  }

  function showMessage(container, message = '') {
    if (!container) return;

    const messageBox = container.querySelector('.cart-discount__message');

    if (!messageBox) return;

    if (!message) {
      messageBox.hidden = true;
      messageBox.textContent = '';
      return;
    }

    messageBox.hidden = false;
    messageBox.textContent = message;
  }

  async function applyDiscount(container) {
    const cartItems = getCartItems();

    if (!cartItems) {
      console.error('CartItems element not found.');
      return;
    }

    const input = container.querySelector('.js-cart-discount-input');

    if (!input) return;

    const code = input.value.trim();

    if (!code) {
      showMessage(container, 'Please enter a discount code.');
      return;
    }

    setLoading(container, true);

    try {
      await cartItems.applyDiscount(code);

      showMessage(container, '');
    } catch (error) {
      console.error(error);
      showMessage(container, error.message || 'Unable to apply discount.');
    } finally {
      setLoading(container, false);
    }
  }

  async function removeDiscount(button) {
    const cartItems = getCartItems();

    if (!cartItems || !cartItems.removeDiscount) return;

    const container = getContainer(button);

    setLoading(container, true);

    try {
      await cartItems.removeDiscount(button.dataset.discountCode);

      showMessage(container, '');
    } catch (error) {
      console.error(error);
      showMessage(container, error.message || 'Unable to remove discount.');
    } finally {
      setLoading(container, false);
    }
  }

  document.addEventListener('click', async (event) => {
    const applyButton = event.target.closest('.js-cart-discount-apply');

    if (applyButton) {
      event.preventDefault();

      await applyDiscount(getContainer(applyButton));

      return;
    }

    const removeButton = event.target.closest('.js-cart-discount-remove');

    if (removeButton) {
      event.preventDefault();

      await removeDiscount(removeButton);
    }
  });

  document.addEventListener('keydown', async (event) => {
    if (event.key !== 'Enter') return;

    const input = event.target.closest('.js-cart-discount-input');

    if (!input) return;

    event.preventDefault();

    await applyDiscount(getContainer(input));
  });
})();